"use client";
import { useMemo as R } from "react";
import { useInkeepConfig as h } from "../../providers/config-provider.js";
import { transformInkeepSource as y } from "../../utils/transform-source/index.js";
const D = (t) => {
  const {
    baseSettings: { transformSource: c, organizationDisplayName: o },
    searchSettings: { tabs: r, shouldOpenLinksInNewTab: f }
  } = h();
  return R(() => {
    const p = r.length > 0 ? r : ["All"], s = {}, b = /* @__PURE__ */ new Set(), u = p.map((e) => typeof e == "string" ? e : e[0]);
    for (const e of u)
      s[e] = [];
    for (const e of t) {
      const a = e.url || "";
      if (b.has(a)) continue;
      b.add(a);
      const i = y(
        {
          title: e.title,
          url: a,
          description: w(e),
          type: I(e.rootRecord.__typename),
          tag: S(e),
          breadcrumbs: e.rootRecord.pathBreadcrumbs ?? [],
          contentType: e.rootRecord.contentType
        },
        "searchResultItem",
        { organizationDisplayName: o, tabs: r, transformSource: c }
      ), n = {
        ...i,
        id: e.id,
        isExternal: i.shouldOpenInNewTab !== void 0 ? i.shouldOpenInNewTab : f
      }, m = n.tabs || [];
      for (const d of m) {
        const l = typeof d == "string" ? d : d[0];
        if (!u.includes(l)) {
          console.warn(`Tab "${l}" found in item but not configured in tabs`);
          continue;
        }
        s[l].push(n);
      }
      u.includes("All") && s.All.push(n);
    }
    for (const e of Object.keys(s)) {
      const a = p.find((n) => typeof n == "string" ? n === e : n[0] === e), i = typeof a == "object" ? a[1]?.isAlwaysVisible === !0 : !1;
      s[e].length === 0 && !i && delete s[e];
    }
    return s;
  }, [t, c, o, r, f]);
}, w = (t) => {
  switch (t.rootRecord.__typename) {
    case "DocumentationRecord": {
      const c = g(t.pathHeadings?.at(-1)?.content || ""), o = g(t.content?.content || "");
      return t.preview || o || c;
    }
    case "GitHubIssueRecord":
    case "StackOverflowRecord":
    case "DiscourseRecord":
      return t.rootRecord.body;
    default:
      return t.preview;
  }
}, S = (t) => {
  switch (t.rootRecord.__typename) {
    case "StackOverflowRecord":
      return t.rootRecord.markedAsCorrectAnswer ? "Resolved" : void 0;
    case "GitHubIssueRecord":
      return t.rootRecord.state === "CLOSED" ? "Closed" : void 0;
  }
}, g = (t) => {
  const c = /(https?:\/\/\S+)/g;
  return t.replace(c, (o) => {
    const r = o.split("/");
    return r.length > 3 ? `...${r.slice(-2).join("/")}` : o;
  });
}, I = (t) => {
  switch (t) {
    case "DocumentationRecord":
      return "documentation";
    case "GitHubIssueRecord":
      return "github_issue";
    case "DiscourseRecord":
      return "discourse";
    case "DiscordRecord":
      return "discord";
    case "StackOverflowRecord":
      return "stackoverflow";
    case "SlackEntry":
      return "slack_message";
    default:
      return "site";
  }
};
export {
  D as useTransformResults
};
